import PageLayout from "../../components/ui/PageLayout";
import PersonalStats from "./PersonalStats";
import GlobalStats from "./GlobalStats";

const StatsPage = () => {
  return (
    <PageLayout>
      <>
        <PersonalStats />
        <GlobalStats />

        {/* Fun fact */}
        <div
          className="absolute top-8 right-0 p-4 bg-[#232222] rounded-lg flex items-center space-x-4"
          style={{ width: "563px", height: "40px", gap: "2px" }}
        >
          <span className="text-2xl">🐶</span>
          <p className="text-sm">
            <strong>Did you know?</strong> All puppies are born with blue eyes –
            their permanent eye color develops over a few weeks.
          </p>
        </div>
      </>
    </PageLayout>
  );
};

export default StatsPage;
